import { Nullable } from "service";
import { ConfirmDialogProps } from "ui";
import { create } from "zustand";

type InternalConfirmDialogProps = Omit<
  ConfirmDialogProps,
  "open" | "onClose"
> & {
  onClose?: () => void;
};

interface DialogStore {
  dialog: Nullable<InternalConfirmDialogProps>;
  setDialog: (data: Nullable<InternalConfirmDialogProps>) => void;
  closeDialog: () => void;
}

// TODO: Expand this into supporting multiple dialogs later down the line
export const useDialogStore = create<DialogStore>((setState) => ({
  dialog: null,
  setDialog: (data: Nullable<InternalConfirmDialogProps>) =>
    setState({ dialog: data }),
  closeDialog: async () => setState({ dialog: null }),
}));
